import React, { useState, useEffect, useMemo } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faExclamationCircle } from '@fortawesome/pro-solid-svg-icons'
import classNames from 'classnames'

import { IAssignedLessonModel } from 'models/assignedLesson.model'
import { useCourse } from 'contexts'
import styles from './LessonNavigation.module.scss'

export interface Props {
  id: number
  lessonName?: string
  lessonState?: IAssignedLessonModel
  currentLesson: any
  index: number
}

const LessonNavigation: React.FC<Props> = (props: Props) => {
  const lessonNavStates = useMemo(
    () => [styles.pending, styles.inProgress, styles.finished],
    []
  )
  const { lessonState, currentLesson, id } = props

  const [customStyles, setCustomStyles] = useState(lessonNavStates[0])
  const {
    multimediaProgress: { finished },
    canAnswer,
  } = useCourse()

  const someLesson = id === currentLesson.id
  useEffect(() => {
    if (currentLesson && currentLesson.id) {
      if (someLesson) {
        setCustomStyles(lessonNavStates[1])
      } else {
        if (lessonState && lessonState.state === 2) {
          setCustomStyles(lessonNavStates[2])
        } else {
          setCustomStyles(lessonNavStates[0])
        }
      }
    }
  }, [currentLesson, id, lessonNavStates, lessonState, someLesson])
  const showWarning = someLesson && !finished && canAnswer
  return (
    <>
      <div
        className={classNames(
          `${styles.block} ${customStyles}`,
          showWarning && styles.warning
        )}
      >
        <div>
          <div className={`${styles.rhombus} icon`}>
            <FontAwesomeIcon
              icon={(showWarning && faExclamationCircle) || faCheck}
              className={classNames(styles.correctCheck, 'h-100')}
            />
          </div>
        </div>
        <div className={`${styles.text} name`}>{props.lessonName}</div>
      </div>
    </>
  )
}

export default LessonNavigation
